<template>
    <tr>
        <td class="minWidth-200">
            <dynamic-dropdown :api-url="'/api/Tariffs/GetEntitiesForDropdown'"
                              :required="true"
                              :field-name="$t('budgetModule.budgetPosition')"
                              v-model="item.tariffItemId"></dynamic-dropdown>
        </td>
        <td class="numberColumnWidth"><input type="number" class="form-control" v-model="item.qty"></td>
        <td class="numberColumnWidth"><input type="number" class="form-control" v-model="item.price"></td>
        <td class="numberColumnWidth">{{ item.total }}</td>
        <!-- Разход -->
        <td class="numberColumnWidth">{{ item.expenseQty }}</td>
        <td class="numberColumnWidth">{{ item.expensePrice }}</td>
        <td class="numberColumnWidth">{{ item.expenseTotal }}</td>
        <td>
            <nomenclature-dropdown :load-by-parent-sort="true"
                                   :parent-sort="financingSort"
                                   :field-name="$t('budgetModule.financing')"
                                   v-model="item.financingId"></nomenclature-dropdown>
        </td>
        <td>{{ balance }}</td>
        <td>
            <i class="fas fa-trash text-danger pointer" @click="deleteItem"></i>
        </td>
    </tr>
</template>

<script>
import DynamicDropdown from '../dropdown/DynamicDropdown';
import { BudgetModuleItemModel } from '../../models/models';
import { NomenclatureParentBySort } from '../../models/enums';
import NomenclatureDropdown from '../dropdown/NomenclatureDropdown';

export default {
    inject: ['$validator'],
    props: {
        item: {
            type: BudgetModuleItemModel,
            default: new BudgetModuleItemModel()
        },
        index: {
            type: Number
        }
    },
    data() {
        return {
            baseUrl: this.$store.getters.baseUrl,
            financingSort: NomenclatureParentBySort.FundingType
        }
    },
    components: {
        DynamicDropdown,
        NomenclatureDropdown
    },
    methods: {
        getSinglePriceFromTariff(tariffItemId) {
            this.$http.get(`/api/Tariffs/GetSinglePrice/${tariffItemId}`).then(result => {
                if (result.data) {
                    this.item.price = result.data.value;
                    this.item.priceId = result.data.priceId;
                }
            });
        },
        clickedItem() {
            this.$emit('clickedItemIndex', this.index);
        },
        deleteItem() {
            this.$emit('deleteItem', this.index);
        }
    },
    computed: {
        balance() {
            const balanceTotal = this.item.total - this.item.expenseTotal;
            return Math.round(balanceTotal * 100) / 100;
        }
    },
    watch: {
        'item.tariffItemId': function (newVal, oldVal) {
            this.getSinglePriceFromTariff(newVal);
        },
        'item.financingId': function (newVal, oldVal) {
            this.$emit('financingTypeChanged');
        },
        'item.qty': function (newVal, oldVal1) {
            this.item.total = Math.round((this.item.qty * this.item.price) * 100) / 100
        },
        'item.price': function (newVal, oldVal1) {
            this.item.total = Math.round((this.item.qty * this.item.price) * 100) / 100;
        },
        'item.expenseQty': function (newVal, oldVal) {
            this.item.expenseTotal = Math.round((this.item.expenseQty * this.item.expensePrice) * 100) / 100;
        },
        'item.expensePrice': function (newVal, oldVal) {
            this.item.expenseTotal = Math.round((this.item.expenseQty * this.item.expensePrice) * 100) / 100;
        }
    },
}
</script>

<style scoped>
.minWidth-200 {
    min-width: 200px;
}

.numberColumnWidth {
    min-width: 70px;
}
</style>
